import React from 'react';
import './BMPFooter.css';

export default function BMPFooter() {
  return (
    <footer className="bmp-footer">
      <span>BanaMarketPlace</span>
      <span className="bmp-footer-sep">|</span>
      <span>BanaPrecios.com &copy; {new Date().getFullYear()}</span>
    </footer>
  );
}
